import { forwardRef, useState } from 'react';

import { Datepicker } from '@mobiscroll/react';
import moment from 'moment/moment';

import { DatePickerStyled } from './DatePickerRange.style';
import { renderDatePickerVariant } from './DatePickerRangeInputVariant';

import type { Moment } from 'moment';

type DatePickerProps = {
  variant?: 'iconButton' | 'input' | 'button';
  isDisabled?: boolean;
  isRequired?: boolean;
  isReadOnly?: boolean;
  isFullWidth?: boolean;
  isShowIcon?: boolean;
  isError?: boolean;
  label?: string;
  placeholder?: string;
  value?: any;
  helperText?: string;
  errorMessage?: string;
  size?: 'small' | 'medium';
  dateFormat?: string;
  onChange: (date: Moment | null) => void;
  onClosePickerCallback?: (date: Moment | null) => void;
  isClearable?: boolean;
  [x: string]: any;
};

export const DatePickerRange = forwardRef<HTMLHeadingElement, DatePickerProps>((props, ref) => {
  const {
    isDisabled,
    isShowIcon = true,
    isError,
    isFullWidth = true,
    isRequired,
    isReadOnly = false,
    errorMessage,
    label,
    placeholder,
    isClearable,
    helperText,
    onClosePickerCallback,
    value,
    size,
    dateFormat,
    variant = 'input',
    onChange,
    ...args
  } = props;
  const [isShowPopup, setIsShowPopup] = useState(false);
  const formattedValue = !!value?.[0]?.isValid() ? [value[0], value?.[1]?.isValid() ? value[1] : null] : null;

  const onOpenPopup = () => {
    setIsShowPopup(true);
  };

  const onClosePopup = (newValue: Moment | null) => {
    onClosePickerCallback?.(newValue);
    setIsShowPopup(false);
  };

  const handleChange = (val: any) => {
    onChange(val.value);
  };

  return (
    <DatePickerStyled>
      <Datepicker
        {...args}
        cssClass="date-picker"
        inputRef={ref}
        themeVariant="light"
        moment={moment}
        onChange={handleChange}
        onOpen={onOpenPopup}
        onClose={(e) => onClosePopup(e.value as Moment | null)}
        firstDay={1}
        select={'range'}
        defaultValue={formattedValue}
        value={formattedValue}
        focusOnClose={false}
        disabled={isDisabled}
        dayNamesMin={['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']}
        controls={['calendar']}
        theme="ios"
        returnFormat="moment"
        dateFormat={dateFormat || 'MMM DD YYYY'}
        touchUi={false}
        inputComponent={renderDatePickerVariant}
        inputProps={{
          isShowIcon,
          isClearable,
          label,
          errorMessage,
          isFullWidth,
          isDisabled,
          isReadOnly,
          isRequired,
          onChange: () => {
            handleChange({ value: null });
            onClosePickerCallback?.(null);
          },
          isError,
          variant,
          placeholder,
          helperText,
          size,
          value: formattedValue,
          isShowPopup,
          dateFormat,
        }}
      />
    </DatePickerStyled>
  );
});
